/**
 * @generated SignedSource<<c8edc1900cc1fabf46ef05ee93329f20>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftItemTileContent_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CollectorTileContent_viewer">;
  readonly " $fragmentType": "NftItemTileContent_viewer";
};
export type NftItemTileContent_viewer$key = {
  readonly " $data"?: NftItemTileContent_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftItemTileContent_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftItemTileContent_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CollectorTileContent_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "8740012e713e110280a81bf50e6c3284";

export default node;
